<div class="row mt-2">
  <div class="col-md-12">
    <cap-kopfdatenelement bodyClass="col-md-10" label="Bereinigungsmarkierung" labelClass="col-md-2">
      <div style="margin-left: -2px">
        @if (recht.mBereinigungsMarkierung.access !== "NONE") {
          <span>{{ recht?.bereinigungsMarkierung | yesNo }}</span>
        }
        @if (recht.mBereinigungsMarkierung.access === "NONE") {
          <span>
            {{ "gemaessGrundbuch" | translate }}
          </span>
        } @else {
          <div>
            <cap-read-more [histInfo]="version?.histInfo" [limit]="162" [text]="recht?.bereinigungsGrund"></cap-read-more>
          </div>
        }
      </div>
    </cap-kopfdatenelement>
  </div>
</div>
